<template>
  <div class="p_f d_f ali_c j_s foot_tab">
    <div
      class="ft_1 t_a ft_out"
      :class="ac == 1 ? 'ac' : ''" @click="$router.push('/')">
      <div v-if="ac == 1"><img src="../assets/images/indexed.png" alt=""></div>
      <div v-else><img src="../assets/images/index.png" alt=""></div>
      <div>首页</div>
    </div>
    <div
      class="ft_1 t_a ft_out"
      :class="ac == 2 ? 'ac' : ''" @click="$router.push('/Mall')">
      <div v-if="ac == 2"><img src="../assets/images/courseed.png" alt=""></div>
      <div v-else><img src="../assets/images/course.png" alt=""></div>
      <div>课程</div>
    </div>
    <div
      class="ft_1 t_a ft_out"
      :class="ac == 3 ? 'ac' : ''" @click="$router.push('/Mine')">
      <div v-if="ac == 3"><img src="../assets/images/oured.png" alt=""></div>
      <div v-else><img src="../assets/images/our.png" alt=""></div>
      <div>我的</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "footTab",
    props:{
      ac:{//标题
        type:Number,
        default:1
      },
    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .foot_tab{
    .ft_out{
      img{
        height: 24px;
        width: auto;
      }
      font-size: 14px;
      font-weight: bold;
      color: #cecece;
      cursor: pointer;
      &.ac{
        color: #f95650;
      }
    }
    width: 100%;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    padding: 10.5px 30px 6px;
    height: 60px;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
    z-index: 999;
  }

</style>
